<template>
  <component-wrapper class="i-frame-fi">
    <grid-container-fi v-if="isMounted">
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12">
        <iframe
          v-if="fields?.source?.value"
          ref="iFrame"
          width="100%"
          :height="customHeight"
          :src="fields.source.value"
          frameborder="0"
          scrolling="no"
          :onload="resizeIframe"
        />
      </div>
    </grid-container-fi>

    <loading-indicator
      v-else
      variant="spinnerLocal"
    />
  </component-wrapper>
</template>

<script>
import iframeResize from '@iframe-resizer/parent';
import { LoadingIndicator } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';

export default {
  name: 'IFrameFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    LoadingIndicator,
  },
  inject: ['fields'],
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    customHeight() {
      return this.fields.iframeHeight?.value || null;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    resizeIframe() {
      if (this.$refs.iFrame) {
        iframeResize(
          {
            resizeFrom: 'child',
            log: false, // Enable console logging
            direction: 'vertical',
            inPageLinks: true,
            waitForLoad: false, // we handle onload ourself
            license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz',
            warningTimeout: APP_ENVIRONMENT !== 'PROD' || this.$fischer.isCM() ? 5000 : 0,
          },
          this.$refs.iFrame,
        );
      } else {
        console.error('missing iframe for resizer');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import './i-frame-fi';
</style>
